<template>
    <div>
       <h4 class="title">回饋金領取紀錄</h4>
       <div class="member_content">
            <table class="table table-bordered">
                <thead>
                    <tr class="success">
                        <td>月份</td>
                        <td>總金額</td>
                        <td>個人</td>
                        <td>組織</td>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(row, index) in this.bonus" >
                      <td>{{row.sdate | formatMonth}}</td>
                      <td>{{row.org_receive_bonus}}</td>
                      <td>{{row.org_person_perfor}}</td>
                      <td>{{row.org_team_perfor}}</td>
                    </tr>
                </tbody>
            </table>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  components: {
    Datepicker
  },
  name: 'Bonus',
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      bonus: [],
      choosemonth: ''
    }
  },
  mounted: function () {
    this.getBonus()
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    getBonus () {
      // let id = this.userID
      let date = new Date(this.choosemonth)
      // let queryDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
      let queryDate = date.getFullYear()
      // console.log(queryDate)
      this.$http.get(this.memberurl + '/member_bonus', {params: {token: this.token, month: queryDate}}).then(function (res) {
        let data = res.body.data
        if (data.bonus.length > 0) {
          this.bonus = data.bonus
        } else {
          window.alert('該月份尚未有回饋金。')
        }
        // console.log(data.order)
      }, function () {
        console.log('failed')
      })
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  },
  filters: {
    formatMonth: function (date) {
      return moment(date).format('YYYY-MM')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Bonus.vue?0bcb4980